import { render, staticRenderFns } from "./EditorButton.vue?vue&type=template&id=d70a9884&scoped=true&"
import script from "./EditorButton.vue?vue&type=script&lang=js&"
export * from "./EditorButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorButton.vue?vue&type=style&index=0&id=d70a9884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70a9884",
  null
  
)

export default component.exports